import { useEffect, useState } from 'react';
import { getDonateRequest } from '../../../api/admin/req-donate.api';

export const useReqAllDonateHook = ({
  pageNumber = 1,
  pageSize = 10,
  isRefetch,
  filters = {}
}: { 
  pageNumber?: number; 
  pageSize?: number;
  isRefetch?: boolean 
  filters?: any;
}) => {
  const [dataList, setDataList] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  const [total, setTotal] = useState<number>(0);
  useEffect(() => {
    getAllReqDonate(pageNumber, pageSize);
  }, [pageNumber, pageSize, isRefetch, filters]);
  const getAllReqDonate = async (page: number, size: number) => {
    try {
      setLoading(true);
      const { data } = await getDonateRequest(page, size, filters);
      setDataList(data?.data);
      setTotal(data?.total)
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };
  return {
    data: dataList,
    loading,
    total
  };
};
